import type { PaigeClient } from '@paige/api-client';
import { tenantHeader, unwrap } from './http';
import type { CompanyApiKey, CompanyApiKeyCreated } from './types';

/** The company's API keys: list without the secret, make with it once, revoke. */
export interface ApiKeysApi {
  list(tenant: string): Promise<CompanyApiKey[]>;
  /** `expiresInDays` absent means the default lifetime (row 45). */
  create(tenant: string, name: string, expiresInDays?: number): Promise<CompanyApiKeyCreated>;
  revoke(tenant: string, keyId: string): Promise<void>;
}

export function apiKeysApi(client: PaigeClient): ApiKeysApi {
  return {
    async list(tenant) {
      return unwrap(
        await client.GET('/company/api-keys', { params: { header: tenantHeader(tenant) } }),
      ) as CompanyApiKey[];
    },
    async create(tenant, name, expiresInDays) {
      return unwrap(
        await client.POST('/company/api-keys', {
          // The contract names the idempotency header; the client's middleware fills the key.
          params: { header: { ...tenantHeader(tenant), 'Idempotency-Key': '' } },
          body: { name, expiresInDays: expiresInDays ?? null },
        }),
      ) as CompanyApiKeyCreated;
    },
    async revoke(tenant, keyId) {
      unwrap(
        await client.DELETE('/company/api-keys/{keyId}', {
          params: { header: tenantHeader(tenant), path: { keyId } },
        }),
      );
    },
  };
}
